export const QUOTE_STATUSES = [
    { value: 'aguardando', label: 'Aguardando' },
    { value: 'solicitacao_alteracao_cliente', label: 'Alteração (cliente)' },
    { value: 'solicitacao_alteracao_vendedor', label: 'Alteração (vendedor)' },
    { value: 'aceito', label: 'Aceito' },
    { value: 'rejeitado', label: 'Rejeitado' },
    { value: 'transformado_em_pedido', label: 'Transformado em pedido' },
    { value: 'arquivado', label: 'Arquivado' },
];

const LABEL_BY_VALUE = QUOTE_STATUSES.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
}, {});

export function quoteStatusLabel(status) {
    const key = String(status || '').trim();
    return LABEL_BY_VALUE[key] || key || '—';
}

export const QUOTE_STATUS_TRANSITIONS = {
    aguardando: [
        'aceito',
        'rejeitado',
        'solicitacao_alteracao_cliente',
        'solicitacao_alteracao_vendedor',
    ],
    solicitacao_alteracao_cliente: ['aguardando'],
    solicitacao_alteracao_vendedor: ['aguardando'],
    aceito: [],
    rejeitado: [],
};

export function quoteEditable(status) {
    const key = String(status || '').trim();
    return key !== 'arquivado' && key !== 'transformado_em_pedido';
}

export function quoteCanConvert(status) {
    return String(status || '').trim() === 'aceito';
}

export function quoteCanArchive(status) {
    const key = String(status || '').trim();
    return key !== 'arquivado' && key !== 'transformado_em_pedido';
}
